import * as React from 'react';

const GoogleWalletPaymentSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 48 32" {...props}>
        <path
            fill="#FFF"
            d="M3 31.5C1.6 31.5.5 30.4.5 29V3C.5 1.6 1.6.5 3 .5h42c1.4 0 2.5 1.1 2.5 2.5v26c0 1.4-1.1 2.5-2.5 2.5H3z"
        />
        <path
            fill="#4688F1"
            d="M45 1c1.1 0 2 .9 2 2v26c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h42m0-1H3C1.3 0 0 1.3 0 3v26c0 1.7 1.3 3 3 3h42c1.7 0 3-1.3 3-3V3c0-1.7-1.3-3-3-3z"
        />
        <path
            fill="#4285F4"
            d="M28.9 5h4.4s.5 0 .6 1.1c.2 1.2 2.6 12.6-.3 20.9-1.5-4.3-4-13.1-4-13.1S29 8 28.3 5.8c-.3-.9.6-.8.6-.8z"
        />
        <path
            fill="#FBBC05"
            d="M25.6 16.4S24.5 21 23.5 23c-1.2-.7-3.2-5.5-3.2-5.5l.1-1.8s.8-5.7.7-6.6c-.1-.7 2.7 1.5 2.7 1.5l1.8 5.8z"
        />
        <path
            opacity={0.5}
            fill="url(#google-wallet-payment_svg__e)"
            d="M35 18.6c-.1 2.8-.5 5.7-1.4 8.4-1.5-4.3-4-13.1-4-13.1l5.4 4.7z"
        />
        <path
            fill="#EA4335"
            d="M21.1 8.9h5.3s.1 0 .3.1c.2.2.5.7 1.1 1.7 1.1 2.1 2 3.3 2.5 4.6 1.1 2.7 2.6 5.7 3.3 11.5h-5.3s-.1-.2-.2-.7c-.8-8.2-7-17-7-17s-.1-.2 0-.2z"
        />
        <path
            opacity={0.5}
            fill="url(#google-wallet-payment_svg__j)"
            d="M24.3 20.4l.1.2c-.3.8-.5 1.5-1 2.4-1.1-.7-2.7-4.5-3.1-5.3v-1.9l.6.5c.1 0 2.3 2 3.4 4.1z"
        />
        <path
            fill="#34A853"
            d="M20.5 16.1c-.3-.6-.7-1.2-1.5-2.3-.3-.5-.4-.6-.4-.6s0-.2-.4-.2h-4.9s-.6.3-.2.6c.3.4 2.6 3.1 3.6 5.9 1 2.8 1 3 1 3s0 .4.5.4h5.3s-.6-2-1-3c-.8-1.7-1.4-2.8-2-3.8z"
        />
    </svg>
);

GoogleWalletPaymentSvg.displayName = 'GoogleWalletPaymentSvg';
export default GoogleWalletPaymentSvg;
